import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { API_AUTH_ENROLL_PHONE_FACTOR_URL } from "constants/apiUrls";

import { AuthTransaction } from "../types/authTransaction";
import { PhoneFactor } from "types/factor/factor";
import { OktaError } from "types/oktaError/oktaError";

import useAuthTransactionApiClient from "./useAuthTransactionApiClient";

export type EnrollPhoneData = {
  stateToken: string;
  factorType: PhoneFactor;
  phoneNumber: string;
};

function useAuthEnrollPhone(): UseMutationResult<
  AuthTransaction,
  OktaError,
  EnrollPhoneData
> {
  const authTransactionApiClient = useAuthTransactionApiClient();

  return useMutation({
    mutationFn: async (data) => {
      const response = await authTransactionApiClient(
        API_AUTH_ENROLL_PHONE_FACTOR_URL,
        {
          method: "POST",
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return await response.json();
      }
    },
  });
}

export default useAuthEnrollPhone;
